/**
 *
 * Asynchronously loads the component for RestaurantsList
 *
 */

import Loadable from 'react-loadable';
import Loader from '../../components/Loader';
// import { fetchResturantPage } from './actions';
// import { DEFAULT_PRE_PAYLOAD } from './constants';

const component = Loadable({
  loader: () => import('../RestaurantsList/index'),
  loading: Loader,
});

const loadData = (store) => { // eslint-disable-line no-unused-vars
  // const { headerContainer: { selectedCity: { city, location } } } = store.getState().toJS();
  // const payload = {
  //   ...DEFAULT_PRE_PAYLOAD,
  //   city,
  //   ...location,
  // };
  return Promise.all([
    // store.dispatch(fetchResturantPage(payload)),
  ]);
};

export default {
  loadData,
  component,
};



// WEBPACK FOOTER //
// client/containers/RestaurantsList/Loadable.js